// Payouts: the weekly statement (what Zuttle owes each operator by EFT, and
// what Paystack paid it at source) and the operator receivables (Paystack
// plan 8, PR 14).

import React, { useState } from 'react';
import WeeklyStatement from './WeeklyStatement';
import ReceivablesList from './ReceivablesList';

const TABS = [
  { id: 'weekly', label: 'Weekly statement' },
  { id: 'receivables', label: 'Receivables' },
];

const PayoutDashboard = () => {
  const [tab, setTab] = useState('weekly');
  return (
    <div>
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-gray-900">{tab === 'weekly' ? 'Weekly Payouts' : 'Operator Receivables'}</h1>
      </div>
      <div className="flex gap-2 border-b border-gray-200 mb-6" role="tablist">
        {TABS.map((t) => (
          <button key={t.id} role="tab" aria-selected={tab === t.id} onClick={() => setTab(t.id)}
            className={`px-4 py-2 text-sm font-medium -mb-px border-b-2 ${tab === t.id ? 'border-emerald-600 text-emerald-700' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'weekly' ? <WeeklyStatement /> : <ReceivablesList />}
    </div>
  );
};

export default PayoutDashboard;
